import { render, staticRenderFns } from "./InsuranceTypesCreate.vue?vue&type=template&id=1e191b03"
import script from "./InsuranceTypesCreate.vue?vue&type=script&lang=js"
export * from "./InsuranceTypesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports